export default "__VITE_ASSET__37a57af3__"